import { secureStorage, StorageKeys } from "@services/secureStorage.service";
import { baseApi } from "@store/apis";

import type { ApiResponse } from "../models";
import type { Challenge, ChallengesRequest } from "./models";


const GetChallengesQuery =baseApi.injectEndpoints({
  endpoints: builder => ({
    GetChallenges: builder.query({
      providesTags: ["Challenges"],
      query: ({
        itemsPerPage,
        page,
        categoryId,
      }: ChallengesRequest) => ({
        url: "GetInfoChallenges",
        params: {
          Page: page,
          ItemsPerPage: itemsPerPage,
          CategoryId: categoryId,
          UserId: secureStorage.get<string>(StorageKeys.USER_ID),
        },
        method: "GET",
      }),
      transformResponse: (response: ApiResponse<Challenge>) => response.result,
    }),
  }),
});
export const { useGetChallengesQuery } = GetChallengesQuery;
